// extracted by mini-css-extract-plugin
export default {"800":"(min-width: 800px)","header":"GMPynjOCIxkzxEE4fQYS","nav":"_IAwiuN25UQ3w5uUIplf","tabview":"kI40gdSlBinPpPe8nAwz"};